import { render, staticRenderFns } from "./teachingClassDialog.vue?vue&type=template&id=4ee5b2ae"
import script from "./teachingClassDialog.vue?vue&type=script&lang=js"
export * from "./teachingClassDialog.vue?vue&type=script&lang=js"
import style0 from "./teachingClassDialog.vue?vue&type=style&index=0&id=4ee5b2ae&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports